
import { TranslationContentType } from "../contentTypes";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

// Requests
export class WebshopLanguagesAsPackageSyncModel extends SyncModel {
  public location: number; // Location
  public code: string; // en,fr
}

// Responses
/** Webshop Sprachen */
export class WebshopLanguagesDataModel extends DataModel {
  public get DM_Key(): number | string { return this.location.toString() + "_" + this.code; }
  public location: number;
  public code: string;
  public deleted: boolean;
  public name: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public change_at_ymd: number;
  public change_at_hms: number;
  /** enthält die übersetzungen, der Key ist der ContentType + "|" + ContentID
   */
  public webshop_language_translations_as_package: { [key: string]: string };

  /** gibt die übersetzung zurück, oder den de_defaultValue */
  public GetTranslation(contentType: TranslationContentType, contentID: number, de_defaultValue: string): string {
    const translation = this.webshop_language_translations_as_package[contentType + "|" + contentID];
    if (translation && translation.length > 0) {
      return translation;
    } else {
      return de_defaultValue;
    }
  }

  /** ContenID Setzt sich zusammen aus (sort_no * 1000000) + SOTItemGroupDataModel.id */
  public static GetSOTItemGroupRecommendationArticleGroup_ContentID(SOTRecommendationArticleGroup_SortNo: number, SOTItemGroup_ID: number): number {
    return (SOTRecommendationArticleGroup_SortNo * 1000000) + SOTItemGroup_ID;
  }

  public DeserializeSubTypes(): void {
    // has no complex type
  }
}

export class WebshopLanguagesAsPackageSyncDataModel extends SyncDataModel {
  public webshop_languages_as_package: WebshopLanguagesDataModel[];
  public get models(): DataModel[] { return this.webshop_languages_as_package; }
  public DeserializeType(): void {
    this._DeserializeType(WebshopLanguagesDataModel);
  }
}